module.exports = __webpack_public_path__ + "img/hôtel.6a0df4d5.png";